import { render, staticRenderFns } from "./VUserCredit.vue?vue&type=template&id=ad52b21a&"
import script from "./VUserCredit.vue?vue&type=script&lang=js&"
export * from "./VUserCredit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports